import { COUNTRY_OPTIONS, LANGUAGE_OPTIONS } from "@/lib/constants/locale-data";

/**
 * Gets the display name for a country code
 * Handles both 2-letter codes (e.g., "US") and full names (e.g., "United States")
 *
 * @param countryCode The country code or name to display
 * @returns The formatted country name
 */
export const getCountryDisplayName = (
  countryCode: string | undefined | null
): string => {
  if (!countryCode) return "N/A";

  // If it's already a full name, return it
  if (countryCode.length > 2) return countryCode;

  // Look up the country code in our options
  const country = COUNTRY_OPTIONS.find(
    (option) => option.value.toLowerCase() === countryCode.toLowerCase()
  );

  return country ? country.label : countryCode;
};

/**
 * Gets the display name for a language code
 * Handles both 2-letter codes (e.g., "en") and full names (e.g., "English")
 *
 * @param languageCode The language code or name to display
 * @returns The formatted language name
 */
export const getLanguageDisplayName = (
  languageCode: string | undefined | null
): string => {
  if (!languageCode) return "N/A";

  // If it's already a full name, return it
  if (languageCode.length > 2) return languageCode;

  // Look up the language code in our options
  const language = LANGUAGE_OPTIONS.find(
    (option) => option.value.toLowerCase() === languageCode.toLowerCase()
  );

  return language ? language.label : languageCode;
};
